import { Vue } from 'vue-property-decorator';
import { SelectableItem } from '@/types/firm/firm';

class FirmItemBus extends Vue {
  selectedItem: SelectableItem | null = null;
}

export default new FirmItemBus();
